import axios from "axios";

class TAUserManagementService {
  getTAUserList = async () => {
    return axios({
      method: "get",
      url: `/users/api/ta-user-management/list`,
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  getExpiryList = async () => {
    return axios({
      method: "get",
      url: `/users/api/ta-user-management/expiry-list`,
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  searchUsers = async (q) => {
    return axios({
      method: "get",
      url: `/users/api/ta-user-management/search-users`,
      params: { q },
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  getTAUserDetail = async (userId) => {
    return axios({
      method: "get",
      url: `/users/api/ta-user-management/detail/${userId}`,
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  enableTA = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/api/ta-user-management/enable`,
      data: JSON.stringify(formdata),
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  updateTAUser = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/api/ta-user-management/update`,
      data: JSON.stringify(formdata),
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  disableTA = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/api/ta-user-management/disable`,
      data: JSON.stringify(formdata),
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  saveMarginMatrix = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/api/dealer/margin-money-control/save`,
      data: JSON.stringify(formdata),
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };

  // multipart, not JSON — the renewal carries optional file uploads.
  // The 409 early-renewal response is a real answer, not a failure, so the
  // error branch returns the body instead of swallowing it.
  renewLimit = async (formData) => {
    return axios({
      method: "post",
      url: `/users/api/ta-user-management/renew-limit`,
      data: formData,
      headers: { "content-type": "multipart/form-data" },
    })
      .then((res) => res.data)
      .catch((err) => err?.response?.data ?? { status: 400, msg: "Failed to renew limit" });
  };

  getRenewalHistory = async (userId) => {
    return axios({
      method: "get",
      url: `/users/api/ta-user-management/renewal-history/${userId}`,
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  };
}

export default new TAUserManagementService();
